import { useState, useEffect } from 'react';

export default function DelayFadeOut({
  children,
}: {
  children: React.ReactNode;
}) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []);
  if (!visible) return null;
  return <div>{children}</div>;
}
